import { defineComponent } from "vue";

const name = 'PDFItensNotaFiscal'

export default defineComponent({
  name,

  components: { }, 

  props: {
    notaFiscal: {
      type: String,
      default: ''
    },
  },

  beforeMount() {
    var today = new Date();
    var year = today.getDate()+" de "+(this.monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  mounted() {
    this.GetItensNotasFiscais()

    var today = new Date();
    var year = today.getDate()+" de "+(this.monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  updated () { },

  data () {
    return {
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      DiaHoje: null,
      itensNotasFiscaisArray: [],
      codigoExterno: null,
      serieNotaFiscal: null,
      notaFiscalCodigoExterno: null,
    }
  },

  methods: {
    GetItensNotasFiscais() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetItensNotasFiscais/${this.notaFiscal}`,
      })
      .then((response) => {
        this.itensNotasFiscaisArray = response.data.data;
        this.codigoExterno = response.data.data[0].codigoExterno;
        this.serieNotaFiscal = response.data.data[0].serieNotaFiscal;
        this.notaFiscalCodigoExterno = response.data.data[0].notaFiscalCodigoExterno;

        this.executaTermino()
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    executaTermino() {                
      this.$emit('termino')              
    },
  },

  computed: { }, 

});

